import { featureFlagsKey } from '@/hooks/keyUtils'
import { FeatureFlags, getFeatureFlags } from '@infraloop/services'
import { useQuery } from '@tanstack/react-query'

/**
 * Loads the backend feature flags (no auth needed, so the signed-out pages can read them
 * too). `selfManagedSubscriptions` gates the terms-of-service link in the footer, the
 * optional billing tab, and the extra fields on the registration form.
 */
const useFeatureFlags = () => {
  const { data: featureFlags, isLoading } = useQuery<FeatureFlags>({
    queryKey: featureFlagsKey(),
    staleTime: 60 * 1000,
    queryFn: () => getFeatureFlags(),
  })

  return {
    featureFlags,
    isLoadingFeatureFlags: isLoading,
  }
}

export default useFeatureFlags
